import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { TranslateService } from '@ngx-translate/core';
import { GeneratePdfService } from '../../../../core/services/generate-pdf.service';

@Component({
  selector: 'app-consultation-report',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './consultation-report.component.html',
  styleUrl: './consultation-report.component.scss',
})
export class ConsultationReportComponent {
  @Input() consultationReportError: string = '';
  @Input() consultationId: string = '';

  constructor(
    private consultationsService: ConsultationsService,
    private translateService: TranslateService,
    private generatePdfService: GeneratePdfService
  ) {}

  ngOnInit() {
    if (this.consultationId) {
      this.getConsultationReport(this.consultationId);
    }
  }

  getConsultationReport(id: string) {
    this.consultationsService.getReport(id).subscribe({
      next: (res) => {
        if (res?.patientRapport === '') {
          this.consultationReportError = this.translateService.instant(
            'noConsultationReportToBeDisplayed'
          );
        } else {
          this.consultationReportError = '';
          this.generatePdfService.displayPdf(
            res.patientRapport,
            'consultationReport'
          );
        }
      },
      error: () => {
        this.consultationReportError = this.translateService.instant(
          'noConsultationReportToBeDisplayed'
        );
      },
    });
  }
}
